{
  "pt": {
    "inspiration": {
      "actions": {
        "delete": "Remover",
        "deleteMultipleInspirations": "Apagar...",
        "delete_cancel": "Anular a eliminação",
        "goBackToInspirationLists": "Inspirações",
        "new": "Foto"
      },
      "labels": {
        "move_to_upload": "Coloque o seu documento na página seguinte ou clique em erop om te uploaden.",
        "noInspirations": "Ainda não há inspirações",
        "upload_autoclose": "Esta janela fechar-se-á automaticamente se todas as imagens forem carregadas."
      },
      "toasts": {
        "upload_success": "{count} inspiração carregada com sucesso | {count} inspirações carregadas com sucesso"
      }
    }
  }
}
